import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { catchError, Observable, retry } from 'rxjs';
import { Constants } from '../constant';
import { Room } from '../models/room';
import { Common } from '../../shared/common';

@Injectable()
export class RoomService {

  constructor(private http: HttpClient) { }

  getAllRooms() {
    return this.http.get<Room>(Constants.getApiEndpoint() + '/room_master/all');
  }

  getAvailabeRooms(start_date, end_date, day, start_time, end_time) {
    return this.http.get<Room>(Constants.getApiEndpoint() + '/room_master/check_room_availability?start_date=' + Common.convertDateFormat(start_date) + '&end_date=' +
      Common.convertDateFormat(end_date) + '&day=' + day + '&start_time=' + start_time + '&end_time=' + end_time);
  }

  getAvailabeRoomsbyDate(start_date, end_date, start_time, end_time) {
    return this.http.get<Room>(Constants.getApiEndpoint() + '/room_master/check_room_availability_by_date?start_date=' + Common.convertDateFormat(start_date) + '&end_date=' +
      Common.convertDateFormat(end_date) + '&start_time=' + start_time + '&end_time=' + end_time);
  }

  getRoomsList(pgIndex: number, pageSize: number) {
    return this.http.get<Room>(Constants.getApiEndpoint() + '/room_master?page=' + pgIndex + "&size=" + pageSize)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getRoom(id: string) {
    if (id === "new") {
      return Observable.of(this.initializeCustomer());
    };
    return this.http.get<Room>(Constants.getApiEndpoint() + '/room_master/' + id).pipe(retry(1), catchError(Common.handleError));
  }

  deleteRoomMaster(id: string) {
    return this.http.delete<Room>(Constants.getApiEndpoint() + '/room_master/' + id).pipe(retry(1), catchError(Common.handleError));
  }

  saveRoomMaster(room: Room) {
    if (room.id === null) {
      return this.createRoomMaster(room);
    }
    return this.updateRoomMaster(room);
  }

  private createRoomMaster(room: Room) {
    room.id = undefined;
    return this.http.post<Room>(Constants.getApiEndpoint() + '/room_master', JSON.stringify(room), Common.httpOptions)
      .pipe(retry(1), catchError(Common.handleError));
  }

  private updateRoomMaster(room: Room) {
    return this.http.post<Room>(Constants.getApiEndpoint() + '/room_master', JSON.stringify(room), Common.httpOptions)
      .pipe(retry(1), catchError(Common.handleError));
  }

  initializeCustomer(): Room {
    // Return an initialized object
    return {
      id: "",
      room_no: "",
      block_name: "",
      capacity: "",
      active: false
    };
  }
}
